import { Colors } from "@/constants/theme";
import Ionicons from "@react-native-vector-icons/ionicons";
import { DrawerActions } from "@react-navigation/native";
import { useNavigation } from "expo-router";
import React from "react";
import {
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  useColorScheme,
  View,
  ViewStyle,
} from "react-native";

interface MenuBarProps {
  style?: StyleProp<ViewStyle>;
}

export function MenuBar({ style }: MenuBarProps) {
  const navigation = useNavigation();
  const colorScheme = useColorScheme();
  const theme = Colors[colorScheme ?? "light"];

  return (
    <View style={[styles.container, style]}>
      <TouchableOpacity
        style={[
          styles.iconButton,
          { backgroundColor: theme.border, borderColor: theme.border },
        ]}
        onPress={() => navigation.dispatch(DrawerActions.toggleDrawer())}
        testID="menu_bar"
      >
        <Ionicons name="menu" size={22} color={theme.text} />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    top: 50, // Default top position, can be overridden
    left: 20,
    zIndex: 10,
  },
  iconButton: {
    width: 44,
    height: 44,
    borderRadius: 22,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.05)",
  },
});
